export var MAX_CHARS = 524288; // the default max length per the html maxlength attribute
// the default max length per the html maxlength attribute
export var MIN_SEARCH_LENGTH = 3;
export var PAUSE = 250;
export var TEXT_SEARCHING = "Searching...";
export var TEXT_NORESULTS = "No results found";
export var CLEAR_TIMEOUT = 100;
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/ng2-completer/globals.js
// module id = ../../../../ng2-completer/globals.js
// module chunks = 37